module.exports = __webpack_public_path__ + "static/media/mask6.3e44f855.JPG";